// Minimal shim for SvelteKit's $env/static/public when building chat-embed via plain Vite.

export const PUBLIC_CHAT_EMBED_INSTANCE_NAME =
	(import.meta.env.PUBLIC_CHAT_EMBED_INSTANCE_NAME as string) ?? ''

export const PUBLIC_CHAT_EMBED_TENANT_NAME =
	(import.meta.env.PUBLIC_CHAT_EMBED_TENANT_NAME as string) ?? ''
